module.exports = __webpack_public_path__ + "media/components/country-flag/static/kh-2a884b857d9cc9072b4da0f7e973c8ad.svg";